const NormalizeZip = (value, previousValue) => {
    if (!value) {
      return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (!previousValue || value.length > previousValue.length) {
      // typing forward
  
      if (onlyNums.length === 6) {
        return onlyNums.slice(0,5) + '-' + onlyNums.slice(5)
      }
    }
    if (onlyNums.length <= 5) {
      return onlyNums
    }
    return onlyNums.slice(0,5) + '-' + onlyNums.slice(5,9)
  }
  
  export default NormalizeZip


// WEBPACK FOOTER //
// ./src/components/wizardSection/normalizeZip.js